import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ApisComponent} from './apis/apis.component';
import {ApiDetailComponent} from './api-detail/api-detail.component';
import {SubscriptionsComponent} from './subscriptions/subscriptions.component';
import {SubscriptionManageComponent} from './subscription-manage/subscription-manage.component';
import {UserAuthorizedGuard} from '../core/user/user.authorized.guard';

const routeApis = {
  path: 'apis',
  component: ApisComponent,
  data: {
    title: 'APIs'
  }
};
const routeSubscriptions = {
  path: 'subscriptions',
  component: SubscriptionsComponent,
  canActivate: [UserAuthorizedGuard],
  data: {
    title: 'My Subscriptions'
  }
};
const apisRoutes: Routes = [
  routeApis,
  {
    path: 'apis/:apiId',
    component: ApiDetailComponent,
    data: {
      title: 'API',
      parents: [
        routeApis
      ]
    }
  },
  routeSubscriptions,
  {
    path: 'apis/:apiId/subscription-create',
    component: SubscriptionManageComponent,
    canActivate: [UserAuthorizedGuard],
    data: {
      title: 'Subscribe',
      parents: [
        routeSubscriptions
      ]
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(apisRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ApisRoutingModule {
}
